import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Import Local Styles
import styles from './tooltip.css';

const Tooltip = ({ children, content }) => {
    const [isVisible, setIsVisible] = useState(false);
    return (
        <div
            className={styles.trigger}
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
            tabIndex={0}
        >
            {children}
            <div className={`${styles.wrapper} ${isVisible ? styles['wrapper--visible'] : ''}`}>
                <div
                    className={`${styles.content}`} dangerouslySetInnerHTML={{ __html: content }}
                    id="tooltip"
                    onMouseDown={ev => ev.preventDefault()}
                />
            </div>
        </div>
    );
};

Tooltip.propTypes = {
    children: PropTypes.node.isRequired,
    content: PropTypes.node.isRequired
};

export default Tooltip;
